import { render, staticRenderFns } from "./NewestDivar.vue?vue&type=template&id=ac9d2f30&scoped=true"
import script from "./NewestDivar.vue?vue&type=script&lang=js"
export * from "./NewestDivar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9d2f30",
  null
  
)

export default component.exports